import { type schemaType } from '~~/shared/api/rurality/v3/users/login-google/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/users/login-google/paramsSchema'
import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~~/modules/auth/stores/userStore'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/users/login-google'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const result = await serverFetchWrapper<paramsType, schemaType>(
    endpoint,
    params,
  )
  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }
  return result
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const result = await browserFetchWrapper<paramsType, schemaType>(
    endpoint,
    params,
  )
  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }
  return result
}
